import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import AppHeader from '../Component/Header';
import AppMenu from '../Component/Menu';
import { store } from '../store';
import dayjs from 'dayjs';
import axios from 'axios';
import AppContext from '../Chat/Widget/AppContext';
import { Button, Table, Layout } from 'antd';
import { Messages } from '../Chat/Widget/WidgetLayout/Messages';
import { useMsal } from '@azure/msal-react';
import { scoutChatCenterServerUrl } from '../autoConfig';
const { Sider, Content } = Layout;

const History = () => {
  const [name, setName] = useState('');
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(true);
  const [data, setData] = useState([
    {
      key: '',
      email: '',
      name: '',
      region: '',
      office: '',
      role: ''
    }
  ]);
  const { instance } = useMsal();
  const signOut = async () => {
    try {
      await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/chatSession/removeSSE?consultantEmail=${name}`
      });
    } catch (error) {
      console.log('error occurred fetching bot response', error);
    }
    localStorage.removeItem('username');
    instance.logout();
    window.location.href = '/';
  };
  const onClick = (e) => {
    if (e.key === '1') {
      window.location.href = '/chat';
    }
    if (e.key === '2') {
      window.location.href = '/team';
    }
    if (e.key === '3') {
      navigate('/history');
      //   window.location.href = '/team';
    }
  };
  const [showMessage, setShowMessage] = useState([]);

  const [role, setRole] = useState('');

  const getAllConsultant = async () => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/chatHistory/${
          role === 'Admin' ? 'getChatsForTeamAdmin' : 'getChatsForConsultant'
        }/${name}`
      });
      const transformedData = response.data
        .map((item) => ({
          ...item,
          key: item.chatId
        }))
        .sort((a, b) => new Date(b.createdTime) - new Date(a.createdTime));
      return transformedData || [];
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  const getChatDetail = async (chatId) => {
    try {
      const response = await axios({
        method: 'get',
        url: `${scoutChatCenterServerUrl}/chatHistory/getChatDetail/${chatId}`
      });
      setShowMessage(response.data.chatHistory);
      return response.data || [];
    } catch (error) {
      console.log('error occurred fetching bot response', error);
      return [];
    }
  };
  const columns = [
    {
      title: 'Created Time',
      dataIndex: 'createdTime',
      key: 'createdTime',
      render: (text) => <div>{dayjs(text).format('ddd, MMM D, h:mm A')}</div>
    },
    {
      title: 'Client Name',
      dataIndex: 'clientName',
      key: 'clientName'
    },
    {
      title: 'Client Debtor',
      dataIndex: 'clientDebtorId',
      key: 'clientDebtorId'
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <div>
          <Button
            type="link"
            onClick={() => {
              getChatDetail(record.chatId);
            }}
          >
            View
          </Button>
        </div>
      )
    }
  ];
  useEffect(() => {
    localStorage.getItem('username') &&
      setName(JSON.parse(localStorage.getItem('username'))[0].value);
    sessionStorage.getItem('role') && setRole(sessionStorage.getItem('role'));
  }, []);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const newOptions = await getAllConsultant();
        setData(newOptions);
      } catch (error) {
        console.error('Failed to fetch options', error);
      }
    };

    name && fetchOptions();
  }, [name]);

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="demo-logo-vertical" />
        <AppMenu activeKey={'3'} onClick={onClick} role={role} />
      </Sider>
      <Layout>
        <AppHeader
          name={name}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
          signOut={signOut}
        />
        <Content className="h-[calc(100vh-64px)] flex">
          <div className="bg-white m-8 w-[30vw]">
            <Table columns={columns} dataSource={data} />
          </div>
          {showMessage.length !== 0 ? (
            <Provider store={store}>
              <AppContext.Provider
                value={{
                  botMsgColor: '#131e26',
                  botMsgBackgroundColor: '#EBECF0'
                }}
              >
                <div
                  className="font-lato w-[70vw] flex flex-col bg-white font-sans rounded-b-[16px] h-full "
                  key="widget"
                >
                  <div className="flex h-full w-full">
                    <div className="w-full h-full">
                      <Messages messageList={showMessage} />
                    </div>
                  </div>
                </div>
              </AppContext.Provider>
            </Provider>
          ) : null}
        </Content>
      </Layout>
    </Layout>
  );
};

export default History;
